/* <ag-faq> — one-open-at-a-time accordion. The open/close animation is pure CSS
 * (grid-template-rows 0fr → 1fr), so this only flips state. Also hides the bottom fade
 * once the scrollable list reaches its end. */
if (!customElements.get('ag-faq')) {
  customElements.define('ag-faq', class extends HTMLElement {
    connectedCallback() {
      this.scroller = this.querySelector('[data-scroll]');
      this.addEventListener('click', (e) => {
        const btn = e.target.closest('.ag-faq__q button');
        if (!btn) return;
        const item = btn.closest('.ag-faq__item');
        const open = btn.getAttribute('aria-expanded') !== 'true';
        this.querySelectorAll('.ag-faq__item.is-open').forEach((it) => it !== item && this.set(it, false));
        this.set(item, open);
        setTimeout(this.fade, 420);
        if (open) setTimeout(() => {
          // Keep the opened answer in view inside the scroll box.
          const top = item.offsetTop; // scroller is position:relative
          if (top < this.scroller.scrollTop || top + item.offsetHeight > this.scroller.scrollTop + this.scroller.clientHeight)
            this.scroller.scrollTo({ top: Math.max(top - 8, 0), behavior: 'smooth' });
        }, 320);
      });
      const fade = this.fade = () => this.classList.toggle('is-end', this.scroller.scrollHeight - this.scroller.scrollTop - this.scroller.clientHeight < 4);
      this.scroller.addEventListener('scroll', fade, { passive: true });
      new ResizeObserver(fade).observe(this.scroller);
      fade();
    }
    set(item, open) {
      item.classList.toggle('is-open', open);
      item.querySelector('.ag-faq__q button').setAttribute('aria-expanded', String(open));
      item.querySelector('.ag-faq__a').toggleAttribute('inert', !open);
    }
  });
}
